import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class SWAlertService {

  constructor() { }

  BoxMsg = {
    Title_Confirm: 'Confirmation',
    Title_Warning: 'Warning',
    Title_Success: 'Action Completed',
    Title_Error: 'Error, Checking Alert',
    Title_info: 'Information',
    Title_Notice: 'Notice',
    Title_Hint: 'Hint',
    Title_Delete: 'Data is deleted.',
    Title_Session: 'Your session expired.',

    ConfirmSaveDraft: 'Do you want to save draft data?',

    Desc_SaveComplete: "Data is already saved.",

    Desc_Confidential_Submit: 'If confidential check box is selected, only requester and approver can view and edit the document.',

    Desc_Confirm_Delete: 'Do you want to delete data?',
    Desc_Success_Delete: 'Data is already deleted.',
    Desc_Warning_Delete: 'Please select <em class="far fa-check-square"></em> data to delete.',

    Desc_Confirm_Cancel: 'Do you want to cancel data?',
    Desc_Confirm_Back: 'Do you want to leave this page ?',

    Desc_Confirm_Save: 'Do you want to save data?',
    Desc_Confirm_Submit: 'Do you want to submit data?',
    Desc_Warning_Save: 'Please fill in required fields.',
    Desc_Success_Save: 'Data is already saved.',

    Desc_Confirm_reset: 'Do you want to reset password?',
    Desc_Success_reset: 'Data is already reset password.',

    Desc_Success_Approve: 'Data is already approved.',
    Desc_Success_Reject: 'Data is already rejected.',
    Desc_Confirm_Approve: 'Do you want to approve data?',
    Desc_Confirm_Reject: 'Do you want to reject data?',
    Desc_Confirm_Recall: 'Do you want to recall data?',
    Desc_Success_Recall: 'Data is already recalled.',

    Desc_CheckBox_Waring: 'Please select the information you want to Post?',
    Desc_CheckBox_Waring_Update_FI_Doc: 'Please select an item.',
    Desc_Success_ExportToSAP: 'Data is already Export to SAP.',
    Desc_Success_PostToSAP: 'Data is already Post to SAP.',
    Desc_Success_Reverse: 'Data is already reversed.',
    Desc_Success_Confirm: 'Data is already Confirm.',

    Desc_Error: 'Something went wrong.',

    Desc_Warning_Duplicate: 'Data is Duplicate',
    Desc_Confirm_Logout: 'Are you sure you want to logout?',
    Desc_Confirm_Reverse: 'Are you sure you want to reverse?',
    Desc_Confirm_Return: 'Are you sure you want to return to verify again?',
    Desc_Confirm_ExportToSAP: 'Do you want to Export to SAP?',
    Desc_Confirm_PostToSAP: 'Do you want to Post to SAP?',
    Desc_Receipt_Duplicate: 'Duplicate Receipt No or Receipt Date.',
    Desc_Invoice_Duplicate: 'Duplicate Invoice No or Invoice Date.',
    Desc_Invoice_TotalNoMatch: 'Total Amount(GL) need to equal with Amount Exclude Vat(Vendor).',
    Desc_Receipt_TotalNoMatch: 'Total Amount(GL) need to equal with Amount Exclude Vat(Vendor).',
    Desc_Base_TotalNoMatch: 'Total WHT Base need to equal with Amount Exclude Vat(Vendor).',
    Desc_Cheque_TotalNoMatch: 'Received Amount is not equal to Cheque Amount.',
    Desc_JV_TotalNoMatch: 'Dr. must be equal to Cr.',
    Desc_Error_WHTCode: 'Plese select WHT Code',
    Desc_Invoice_GCI: 'Duplicate GL ,CostCenter ,IO.',
    Desc_Warning_Status: 'Status is ',
    Desc_Error_Information: 'Fill out the wrong information',
    Desc_Error_Permission: 'You do not have permission to access.',
    Desc_Error_NoFIDoc: 'ไม่สามารถ Reverse รายการดังกล่าวได้ เนื่องจากไม่มี FI Doc ในระบบ',
    Desc_Error_Negative_Value: 'Total Amount(GL) need to More than 0.',
    Desc_Error_Excel_Template: 'Excel Template is not Mapping',
    Desc_Error_Amount: 'The value of WHT amount can not be changed more than 1',

    Desc_Success_Sent_Email: 'System send your username and password to email.',
    Desc_Error_Incorrect: 'The username or email is incorrect',
    Desc_Success_Sent_Email_Change_PWD: 'System sent the email for confirmation password has just been changed.',
    Desc_Error_Incorrect_Change_PWD: 'The username or password is incorrect',
    Desc_Warning_Information: 'Please fill in information',
    Desc_Invoice_NoMatch: 'Not match Invoice No.',
    Desc_Receipt_NoMatch: 'Not match Receipt No.',
    Desc_Specify_AddInvoice: 'Please Specify Employee Name or Vendor Name ,TAX ID, Address.',
    Desc_Specify_Comment: 'Please Specify Comment.',
    Desc_Specify_Require: 'Please Specify All Require Filed.',
    Desc_Specify_JV: 'Please specify Dr. and Cr. amount.',

    DescOneVendorLength: 'One time Vendor can not be greater than 10 character?'
  };

  SwAlert = {
    info: function (sTitle: any, message: any, fnOK: any) {
      Swal.fire({
        title: sTitle == undefined ? 'Success' : sTitle + '',
        html: message,
        icon: 'info',
        confirmButtonText: '<em class="fas fa-check"></em> close',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        if (result.value) {
          if (fnOK != undefined) {
            fnOK();
          }
          else {
            Swal.close();
          }
        }
      });
    },
    infoConfidential: function (sTitle: any, message: any, fnOK: any, fnNo: any) {
      Swal.fire({
        title: sTitle == undefined ? 'Success' : sTitle + '',
        html: message,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<em class="fas fa-check"></em> Yes',
        cancelButtonText: '<em class="fas fa-times"></em> No',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(function (d) {
        if (d.dismiss === Swal.DismissReason.cancel) {
          if (fnNo != undefined) {
            fnNo();
          }
          Swal.close();
        }
      });
    },
    Success: function (sTitle, sMessage, fnOK) {
      Swal.fire({
        title: sTitle == undefined ? 'Success' : sTitle + '',
        html: sMessage,
        icon: 'success',
        confirmButtonText: '<em class="fas fa-check"></em> Close',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(function (result) {
        if (result.value) {
          if (fnOK != undefined) {
            fnOK();
          }
          else {
            Swal.close();
          }
        }
      });
    },
    Error: function (sTitle, sMessage, fnOK) {
      Swal.fire({
        icon: 'error',
        title: sTitle == undefined ? 'Success' : sTitle + '',
        html: sMessage,
        confirmButtonText: '<em class="fas fa-check"></em> Close',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(function (result) {
        if (result.value) {
          if (fnOK) {
            fnOK();
          }
          else {
            Swal.close();
          }
        }
      });
    },
    Warning: function (sTitle, sMessage, fnOK) {
      Swal.fire({
        icon: 'warning',

        title: sTitle == undefined ? 'Success' : sTitle + '',
        html: sMessage,
        confirmButtonText: '<em class="fas fa-check"></em> Close',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(function (result) {
        if (result.value) {
          if (fnOK) {
            fnOK();
          }
          else {
            Swal.close();
          }
        }
      });
    },
    Confirm: function (sTitle, sMessage, fnYes, fnNo) {
      Swal.fire({
        title: sTitle,
        text: sMessage,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<em class="fas fa-check"></em> Yes',
        cancelButtonText: '<em class="fas fa-times"></em> No',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        timerProgressBar: true,
        preConfirm: function () {
          return new Promise(function (resolve, reject) {
            Swal.disableButtons();
            if (fnYes != undefined) {
              fnYes();
            }
            Swal.close();
          });
        },
      }).then(function (d) {
        if (d.dismiss === Swal.DismissReason.cancel) {
          if (fnNo != undefined) {
            fnNo();
          }
          Swal.close();
        }
      });
    },
    Confirm0: function (sTitle, sMessage, fnYes, fnNo) {
      Swal.fire({
        title: sTitle,
        text: sMessage,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<em class="fas fa-check"></em> Save',
        cancelButtonText: '<em class="fas fa-times"></em> No',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        timerProgressBar: true,
        preConfirm: function () {
          return new Promise(function (resolve, reject) {
            Swal.disableButtons();
            if (fnYes != undefined) {
              fnYes();
            }
            Swal.close();
          });
        },
      }).then(function (d) {
        if (d.dismiss === Swal.DismissReason.cancel) {
          if (fnNo != undefined) {
            fnNo();
          }
          Swal.close();
        }
      });
    },
    Confirm1: function (sTitle, sMessage, fnYes, fnNo) {
      Swal.fire({
        title: sTitle,
        text: sMessage,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<em class="fas fa-check"></em> Save and Confirm',
        cancelButtonText: '<em class="fas fa-times"></em> No',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        timerProgressBar: true,
        preConfirm: function () {
          return new Promise(function (resolve, reject) {
            Swal.disableButtons();
            if (fnYes != undefined) {
              fnYes();
            }
            Swal.close();
          });
        },
      }).then(function (d) {
        if (d.dismiss === Swal.DismissReason.cancel) {
          if (fnNo != undefined) {
            fnNo();
          }
          Swal.close();
        }
      });
    },
    ConfirmSession: function (sTitle, sMessage, fnYes, fnNo) {
      Swal.fire({
        title: sTitle,
        html: sMessage,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<em class="fas fa-check"></em> Yes',
        cancelButtonText: '<em class="fas fa-times"></em> No',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        timerProgressBar: true,
        preConfirm: function () {
          return new Promise(function (resolve, reject) {
            Swal.disableButtons();
            if (fnYes != undefined) {
              fnYes();
            }
            Swal.close();
          });
        },
      }).then(function (d) {
        if (d.dismiss === Swal.DismissReason.cancel) {
          if (fnNo != undefined) {
            fnNo();
          }
          Swal.close();
        }
      });
    },
    DisableButton: Swal.disableButtons,
    Close: Swal.close
  }
}
